const translations = {
    generateButton: 'Generate Application Map',
    noMaps: 'No Maps Available',
    selectDate: 'Select Date Range',
    title: 'Application Maps'
};

export default translations;
